"use strict";
// These enums are kept in a separate file to avoid transpilation issues.
// If there are any circular dependencies in files with enums, they will not be
// transpiled correctly:
//
// https://github.com/kulshekhar/ts-jest/issues/281
// https://github.com/Microsoft/TypeScript/issues/5243#issuecomment-147766222
Object.defineProperty(exports, "__esModule", { value: true });
exports.TASK_NAMES = exports.TaskSections = exports.CUSTOMER_TASKS = exports.Tasks = void 0;
var Tasks;
(function (Tasks) {
    Tasks["BEDROOMS"] = "BEDROOMS";
    Tasks["BATHROOMS"] = "BATHROOMS";
    Tasks["AMENITIES_FEATURES"] = "AMENITIES_FEATURES";
    Tasks["PROPERTY_COMPOSITION"] = "PROPERTY_COMPOSITION";
    Tasks["LOCATION"] = "LOCATION";
    Tasks["LOCAL_LICENCE"] = "LOCAL_LICENCE";
    Tasks["ARRIVALS_DEPARTURES"] = "ARRIVALS_DEPARTURES";
    Tasks["HOUSE_RULES"] = "HOUSE_RULES";
    Tasks["PRICING"] = "PRICING";
    Tasks["CLEANING_FEE"] = "CLEANING_FEE";
    Tasks["SECURITY_DEPOSIT"] = "SECURITY_DEPOSIT";
    Tasks["TOURIST_TAX"] = "TOURIST_TAX";
    Tasks["INTERNAL_NAME"] = "INTERNAL_NAME";
    Tasks["PHOTOS"] = "PHOTOS";
    Tasks["LISTING_HEADLINE"] = "LISTING_HEADLINE";
    Tasks["LISTING_DESCRIPTION"] = "LISTING_DESCRIPTION";
    Tasks["BOOKING_AVAILABILITY"] = "BOOKING_AVAILABILITY";
    Tasks["BOOKING_NOTICE"] = "BOOKING_NOTICE";
    Tasks["COMMISSION"] = "COMMISSION";
    Tasks["CHANNEL_SELECTION"] = "CHANNEL_SELECTION";
    Tasks["PROMOTIONS"] = "PROMOTIONS";
    Tasks["PERSONAL_DETAILS"] = "PERSONAL_DETAILS";
    Tasks["TERMS_CONDITIONS"] = "TERMS_CONDITIONS";
})(Tasks = exports.Tasks || (exports.Tasks = {}));
exports.CUSTOMER_TASKS = [Tasks.CHANNEL_SELECTION, Tasks.COMMISSION, Tasks.PERSONAL_DETAILS, Tasks.TERMS_CONDITIONS];
var TaskSections;
(function (TaskSections) {
    TaskSections["BEDS_BATHS_AMENITIES"] = "BEDS_BATHS_AMENITIES";
    TaskSections["ARRIVALS_HOUSE_RULES"] = "ARRIVALS_HOUSE_RULES";
    TaskSections["PRICING_FEES"] = "PRICING_FEES";
    TaskSections["PHOTOS_DESCRIPTION_AVAILABILITY"] = "PHOTOS_DESCRIPTION_AVAILABILITY";
    TaskSections["CHANNELS"] = "CHANNELS";
    TaskSections["ACCOUNT"] = "ACCOUNT";
})(TaskSections = exports.TaskSections || (exports.TaskSections = {}));
exports.TASK_NAMES = {
    [Tasks.BEDROOMS]: 'Bedrooms',
    [Tasks.BATHROOMS]: 'Bathrooms',
    [Tasks.AMENITIES_FEATURES]: 'Amenities and features',
    [Tasks.PROPERTY_COMPOSITION]: 'Property composition',
    [Tasks.LOCATION]: 'Location',
    [Tasks.LOCAL_LICENCE]: 'Local licence',
    [Tasks.ARRIVALS_DEPARTURES]: 'Arrivals and departures',
    [Tasks.HOUSE_RULES]: 'House rules',
    [Tasks.PRICING]: 'Nightly pricing',
    [Tasks.CLEANING_FEE]: 'Cleaning fee',
    [Tasks.SECURITY_DEPOSIT]: 'Security deposit',
    [Tasks.TOURIST_TAX]: 'Tourist tax',
    [Tasks.INTERNAL_NAME]: 'Property nickname',
    [Tasks.PHOTOS]: 'Photos',
    [Tasks.LISTING_HEADLINE]: 'Listing headline',
    [Tasks.LISTING_DESCRIPTION]: 'Listing description',
    [Tasks.BOOKING_AVAILABILITY]: 'Booking availability',
    [Tasks.BOOKING_NOTICE]: 'Booking notice',
    [Tasks.CHANNEL_SELECTION]: 'Channel selection',
    [Tasks.PROMOTIONS]: 'Promotions',
    [Tasks.COMMISSION]: 'Fees',
    [Tasks.PERSONAL_DETAILS]: 'Personal details',
    [Tasks.TERMS_CONDITIONS]: 'Terms and conditions'
};
//# sourceMappingURL=constants.js.map